import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import BMXSeparator from "../../../../../../Components/Separator/BMXSeparator";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import BMXTextField from "../../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXDatePicker from "../../../../../../Components/Inputs/BMXDatePicker/BMXDatePicker";

import { updateDashboardByName } from "../../../../../../Utils/Sockets";
import { show } from "redux-modal";
import BMXSelectField from "../../../../../../Components/Inputs/BMXSelectField/BMXSelectField";
import { Box, FormGroup, Stack, Switch, Typography } from "@mui/material";
import BMXTimePicker from "../../../../../../Components/Inputs/BMXTimePicker/BMXTimePicker";
import BMXServiceRadioButton from "../../../../../../Components/Inputs/BMXServiceRadioButton/BMXServiceRadioButton";
import TwoColumnSelectList from "../../../../../../Components/TwoColumnSelectList/TwoColumnSelectList";
import BMXMultiListSelect from "../../../../../../Components/Inputs/BMXMultiListSelect/BMXMultiListSelect";

import { useServiceFormLogic } from "../ServiceHooks/useServiceFormLogic";
import { useCreateServiceStepTwoDictionaries } from "../ServiceHooks/useCreateServiceStepTwoDictionaries";
import { useContacts } from "../../../../../../Hooks/useContactsHook/useContacts";
import { useTechnicians } from "../../../../../../Hooks/useTechniciansHook/useTechnicians";

const CreateServiceFormStepTwo = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const REGISTRY_NAME = "contact";
  const { values, form, initialValues } = props;

  //słowniki tylko dla StepTwo
  const { serviceTasks, serviceProblems, additionalInfoSelect } =
    useCreateServiceStepTwoDictionaries();

  // 🔹 logika formularza StepTwo
  const { leaderUuid, leaderSelected, isGroupEnabled, setIsGroupEnabled } =
    useServiceFormLogic({
      values,
      form,
      initialValues,
    });

  // 🔹 technicy zależni od lidera
  const { allTechnicians, techniciansWithoutLeader } =
    useTechnicians(leaderUuid);

  // 🔹 kontakty
  const { getContactData } = useContacts();

  const techniciansInTheGroup =
    initialValues?.techniciansInTheGroup?.map((el) => ({
      value: el.uuid,
      name: `${el.name || ""} ${el.lastname || ""}`,
      uuid: el.uuid,
    })) || [];

  return (
    <div>
      <Row
        style={{
          display: "inline-flex",
          alignContent: "center",
          alignItems: "center",
        }}
      ></Row>

      <div className="step-two-wrapper">
        <div className="col-left">
          <Col xs={12}>
            {" "}
            <BMXSeparator title={t("global:service.basicInformation")} />
          </Col>
          <Row>
            <Col xs={6}>
              <Field
                data-cy="requester"
                beforeIcon="people"
                afterIcon="add"
                afterIconSize="18px"
                afterIconClick={() => {
                  const contactUuid =
                    values?.device?.client?.uuid ||
                    values?.device?.client?.value;
                  const updateSingleRegistry = () =>
                    updateDashboardByName(REGISTRY_NAME, contactUuid);
                  dispatch(
                    show("RepresentativesModal", {
                      loadData: async () => {
                        await getContactData(values?.device?.client?.name);
                      },
                      header: t("global:contact.representativeAdd"),
                      updateSingleRegistry,
                      uuid: contactUuid,
                    }),
                  );
                }}
                disabled={!values?.device?.client}
                component={BMXSelectField}
                values={values?.device?.client?.representatives?.map((el) => ({
                  value: el.uuid,
                  name: `${el.name || ""} ${el.lastname || ""}`,
                }))}
                label={`${t(
                  "global:secretariatCorespondenceContact.representative",
                )}`}
                name="requester"
                renderValue={(el) => {
                  return `${el.name || ""} ${el.lastname || ""}`;
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={5}>
              <Field
                data-cy="preferredTechnician"
                disabled={!values?.device?.client}
                component={BMXSelectField}
                values={allTechnicians}
                label={`${t("service.preferredTechnician")}`}
                name="preferredTechnician"
                renderValue={(el) => {
                  return `${el.name || ""} ${el.lastname || ""}`;
                }}
              />
            </Col>
            <Col>
              <Field
                name="expectedServiceDateTime"
                component={BMXDatePicker}
                label={t("global:service.expectedServiceDateTime")}
              />
            </Col>
            <Col>
              <Field
                name="expectedServiceTime"
                component={BMXTimePicker}
                label={t("global:crm.nextEventTime")}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={5}>
              <Field
                data-cy="technicianOrTeamLeader"
                disabled={!values?.device?.client}
                component={BMXSelectField}
                values={allTechnicians}
                label={`${t("global:service.technicianOrTeamLeader")}`}
                name="technicianOrTeamLeader"
                renderValue={(el) => {
                  return `${el.name || ""} ${el.lastname || ""}`;
                }}
              />
            </Col>
            <Col>
              <Field
                name="plannedServiceDateTime"
                component={BMXDatePicker}
                label={t("global:service.plannedServiceDateTime")}
              />
            </Col>
            <Col>
              <Field
                name="plannedServiceTime"
                component={BMXTimePicker}
                label={t("global:crm.nextEventTime")}
              />
            </Col>
          </Row>
          <Row
            style={{
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Col>
              <FormGroup>
                <Stack
                  direction="row"
                  sx={{
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  spacing={1}
                >
                  <Switch
                    sx={{
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        color: "#19aa8d", // kolor “kółka”
                      },
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                        {
                          backgroundColor: "#19aa8d", // kolor paska kiedy włączony
                        },
                    }}
                    checked={isGroupEnabled}
                    disabled={!leaderSelected}
                    onChange={(e) => setIsGroupEnabled(e.target.checked)} // ← aktualizacja
                    size="small"
                  />
                  <Typography sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>
                    Grupa serwisowa
                  </Typography>
                </Stack>
              </FormGroup>
            </Col>
            <Col xs={9}>
              <Field
                data-cy="techniciansInTheGroup"
                multiple
                disabled={!values?.device?.client || !isGroupEnabled}
                component={BMXSelectField}
                values={techniciansWithoutLeader}
                selectedValues={values}
                displayEmpty
                initialValues={{ techniciansInTheGroup }}
                label={`${t("global:service.techniciansInTheGroup")}`}
                name="techniciansInTheGroup"
                renderValue={(el) => {
                  return el.map((e) => e.name).join(", ");
                }}
              />
            </Col>
          </Row>
        </div>
        <div className="col-right">
          <Col xs={12}>
            {" "}
            <BMXSeparator title={t("global:service.instruction")} />
          </Col>
          <Row alignItems="flex-start">
            <Col xs={6}>
              <Field
                name="location"
                component={BMXServiceRadioButton}
                options={[
                  { value: "noInformation", icon: "do_disturb", label: "Brak" },
                  {
                    value: "customerIntervention",
                    icon: "airport_shuttle",
                    label: "u Klienta",
                  },

                  {
                    value: "localIntervention",
                    icon: "apartment",
                    label: "Lokalnie",
                  },
                  {
                    value: "remoteIntervention",
                    icon: "headset_mic",
                    label: "Zdalnie",
                  },
                ]}
                defaultValue="noInformation"
                label={t("global:service.locationSelect")}
              />
            </Col>

            <Col xs={6}>
              <Box sx={{ position: "relative" }}>
                <Field
                  name="additionalInfo"
                  component={BMXMultiListSelect}
                  label="Informacje dodatkowe"
                  slotProps={{
                    inputLabel: {
                      fontSize: "0.8rem",
                    },
                  }}
                  maxHeight={200}
                  options={additionalInfoSelect}
                />
              </Box>
            </Col>
          </Row>
          <Row>
            <Col xs={{ span: 6 }}>
              <Field
                name="workImpact"
                component={BMXServiceRadioButton}
                options={[
                  {
                    value: "NoInformation",
                    icon: "do_disturb",
                    label: "Brak",
                    color: "#748EB6",
                  },
                  {
                    value: "Possible",
                    icon: "airport_shuttle",
                    label: "Możliwe",
                    color: "#19AA8D",
                  },
                  {
                    value: "Difficult",
                    icon: "apartment",
                    label: "Utrudniono",
                    color: "#FF9800",
                  },
                  {
                    value: "Impossible",
                    icon: "headset_mic",
                    label: "Niemożliwe",
                    color: "#F44336",
                  },
                ]}
                defaultValue="NoInformation"
                label={t("global:service.workImpact")}
              />
            </Col>
          </Row>
        </div>
      </div>
      <div className="step-two-wrapper-mid">
        <div className="col-left">
          <Row>
            <Col xs={12}>
              {" "}
              <BMXSeparator title={t("global:service.problemDescription")} />
            </Col>
            <Col>
              <Field
                name="problemDescriptionsDictionary"
                component={TwoColumnSelectList}
                label="Problemy"
                // selectedBackgroundColor={"#4c82a6"}
                // fontColor={"#fff"}
                options={serviceProblems}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: "1rem",}}>
            <Col>
              <Field
                name="otherProblem"
                label={`${t("global:service.otherProblem")}`}
                component={BMXTextField}
                data-cy="otherProblem"
              />
            </Col>
          </Row>
        </div>
        <div className="col-right">
          <Row>
            <Col xs={12}>
              {" "}
              <BMXSeparator title={t("global:service.todo")} />
            </Col>
            <Col>
              <Field
                name="tasksDictionary"
                component={TwoColumnSelectList}
                label="Do wykonania"
                selectedBackgroundColor={"#4c82a6"}
                fontColor={"#fff"}
                options={serviceTasks}
              />
            </Col>
          </Row>
          <Row
            style={{
              justifyContent: "center",
              alignItems: "center",
              marginTop: "1rem",
            }}
          >
            <Col xs={10}>
              <Field
                name="otherTask"
                label={`${t("global:service.otherTask")}`}
                component={BMXTextField}
                data-cy="otherTask"
              />
            </Col>
            <Col>
              <FormGroup>
                <Stack direction="row">
                  <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
                    Pilne
                  </Typography>
                  <Field name="urgent">
                    {({ input }) => (
                      <Switch
                        checked={!!input.value}
                        onChange={(e) => input.onChange(e.target.checked)}
                        size="small"
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "red",
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                            {
                              backgroundColor: "red",
                            },
                        }}
                      />
                    )}
                  </Field>
                </Stack>
              </FormGroup>
            </Col>
          </Row>
        </div>
      </div>
      <Row>
        <Col xs={12}>
          {" "}
          <BMXSeparator
            title={t("global:service.additionalLogisticsDescription")}
          />
        </Col>
        <Col xs={12}>
          <Field
            name="additionalLogisticsDescription"
            label={`${t("global:service.additionalLogisticsDescription")}`}
            component={BMXTextField}
            data-cy="additionalLogisticsDescription"
          />
        </Col>
      </Row>
    </div>
  );
};

export default CreateServiceFormStepTwo;
